import { ChatStreamEntryPointSchema, type ChatStreamEntryPoint } from '@packages/types';

/**
 * Ask Bill hands a prompt to the dashboard chat, which SENDS it on arrival.
 * The prompt travels in router state, never in the URL: a query parameter
 * would let any link make the chat agent act as the signed-in user. Router
 * state can only be set by in-app navigation.
 */

/** Where an Ask Bill hand-off came from; the composer is the dashboard's own input, so it is not one. */
export type AskBillEntryPoint = Exclude<ChatStreamEntryPoint, 'composer'>;

const AskBillEntryPointSchema = ChatStreamEntryPointSchema.exclude(['composer']);

interface AskBillLocationState {
  askBill: string;
  askBillEntryPoint?: AskBillEntryPoint;
}

export interface AskBill {
  prompt: string;
  /** Null when the sender did not say where the prompt came from. */
  entryPoint: AskBillEntryPoint | null;
}

export function askBillState(prompt: string, entryPoint?: AskBillEntryPoint): AskBillLocationState {
  return entryPoint ? { askBill: prompt, askBillEntryPoint: entryPoint } : { askBill: prompt };
}

/** The hand-off carried by `location.state`, or null when there is none. */
export function readAskBill(state: unknown): AskBill | null {
  if (typeof state !== 'object' || state === null || !('askBill' in state)) return null;
  const prompt = state.askBill;
  if (typeof prompt !== 'string') return null;
  const trimmed = prompt.trim();
  if (trimmed === '') return null;
  const entryPoint = 'askBillEntryPoint' in state ? AskBillEntryPointSchema.safeParse(state.askBillEntryPoint) : null;
  return { prompt: trimmed, entryPoint: entryPoint?.success ? entryPoint.data : null };
}
